<template>
  <v-flex>
    <v-dialog
      v-if="this.modelTarifa"
      v-model="dialogFormularioTarifa"
      :max-width="400"
      persistent
    >
      <tarifa-formulario
        @cerrarFormularioTarifa="dialogFormularioTarifa = false"
        :modelTarifa="this.modelTarifa"
        :accion="this.accion"
      />
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon
            size="30"
            :color="'white'"
            @click="showConfirmacionEliminacion = false"
            >mdi-close-circle</v-icon
          >
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la reparación?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip
              class="mr-4"
              label
              color="blue-grey darken-3"
              @click="_eliminarTarifa()"
            >
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip
              label
              class="ml-4"
              color="blue-grey darken-3"
              @click="showConfirmacionEliminacion = false"
            >
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="mt-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">TARIFAS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- <v-chip class="mr-4" :color="colorAccent2" link @click="_imprimir">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-printer</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">IMPRIMIR</h5>
        </v-chip> -->
        
      </v-toolbar>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear
            class="mt-12 mb-12"
            :color="colorEBikeAccent1"
            indeterminate
            width="200px"
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="mt-2 mb-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="tarifas" class="mt-0" justify="start" dense>
          <v-col cols="12">
            <v-data-table
              locale="es"
              v-if="tarifas"
              dense
              light
              :headers="headersLargo"
              :items="tarifas"
              :items-per-page="tarifas.length"
              hide-default-footer
              class="elevation-1"
            >
              

              <template v-slot:[`item.action`]="{ item }">
                <v-chip
                  class="mr-1"
                  label
                  small
                  :color="colorAccent2"
                  text-color="white"
                  link
                  @click="_editar(item)"
                >
                  Editar
                </v-chip>

              <!--  <v-chip
                  label
                  small
                  color="red lighten-2"
                  text-color="white"
                  link
                  @click="_delete(item)"
                >
                  Eliminar
                </v-chip>
              -->
                
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import TarifaFormulario from "../components/formularios/TarifaFormulario";

export default {
  components: {
    TarifaFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    accion: "",

    dialogFormularioTarifa: false,
    modelTarifa: null,
    showConfirmacionEliminacion: false,

    headersLargo: [
      // { text: "ID", width: "80px", align: "left", sortable: false, value: "id" },
      {
        text: "NOMBRE",
        align: "left",
        sortable: false,
        width: 300,
        value: "nombre",
      },
      {
        text: "PRECIO",
        align: "right",
        sortable: false,
        width: 100,
        value: "precio",
      },
      {
        text: "DESCRIPCION",
        align: "left",
        sortable: false,
        value: "descripcion",
      },
     
     
      {
        text: "ACCION",
        width: "140px",
        value: "action",
        sortable: false,
        align: "center",
      },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("tarifas", ["tarifas", "tarifaSelec"]),
  },

  watch: {},

  mounted() {
    this._getTarifas(true);
  },

  methods: {
    ...mapActions("tarifas", [
      "getTarifas",
      "eliminarTarifa",
      "updateTarifa",
    ]),
    ...mapMutations("tarifas", ["setTarifaSelec"]),

    _inicializarModelTarifa() {
      this.modelTarifa = {
        id: null,
        nombre: null,
        descripcion: null,
        precio: null,
      };
    },

  

    
   

    async _getTarifas(showload) {
      const params = {};
      await this.getTarifas([this.access_token, params, true]);
    },

    _delete(item) {
      this.setTarifaSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    _crearTarifa() {
      this._inicializarModelTarifa();
      this.accion = "crear";
      this.dialogFormularioTarifa = true;
    },

    _editar(item) {
      this.setTarifaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.tarifaSelec));
      this.modelTarifa = temp;
      this.accion = "editar";
      this.dialogFormularioTarifa = true;
    },

    async _eliminarTarifa() {
      this.showConfirmacionEliminacion = false;
      if (this.tarifaSelec != null) {
        await this.eliminarTarifa([
          this.access_token,
          this.tarifaSelec.id,
        ]);
      }
    },
  },
};
</script>
